import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your existing translation files
const enTranslation = require("./locales/en/translation.json");
const mrTranslation = require("./locales/mr/translation.json");

// Import home page translations
const enHome = require("./locales/en/home.json");
const mrHome = require("./locales/mr/home.json");

// Import stallform translations
const enStallForm = require("./locales/en/stallform.json");
const mrStallForm = require("./locales/mr/stallform.json");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: { ...enTranslation, ...enHome, ...enStallForm },
      },
      mr: {
        translation: { ...mrTranslation, ...mrHome, ...mrStallForm },
      },
    },
    lng: "mr", // default language
    fallbackLng: "mr",
    debug: false,
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
  });

export default i18n;